import type { LookupsType } from './types/api/analytics-lookups-api';
import { fetchers } from './fetchers';

let lookups: LookupsType | undefined = window?.pesAnalytics?.lookups;

export const getLookup = (host, cc, lc) => {
  fetchers
    .getAnalyticsLookupFetcher({
      host,
      countryCode: cc,
      languageCode: lc,
    })
    .then((data) => {
      lookups = data;
    })
    .catch((err) => {
      console.error(err);
    });
};

export const getLookupValueFunction = (
  lookupKey: keyof LookupsType,
): ((key: string, id?: string) => string) => {
  return (key: string, id: string) => {
    if (!lookups) {
      return '';
    }
    let value = lookups[lookupKey][key] || '';
    if (id) {
      value = `${value.split(':')[0]}:${id}`;
    }
    return value;
  };
};

export const getLookupValueAddCartLocation = getLookupValueFunction('addCartLocation');
export const getLookupValueAddCartCTAType = getLookupValueFunction('addCartCTAType');
export const getLookupValueProductLists = getLookupValueFunction('productLists');
export const getLookupValueVirtualPageType = getLookupValueFunction('virtualPageTypes');
export const getLookupValueVirtualPageName = getLookupValueFunction('virtualPageName');
export const getLookupValuePageTabs = getLookupValueFunction('pageTabs');
